import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './matt-scandalis.jpg';

export const MattScandalis: PersonInfo = {
  firstName: 'Matt',
  lastName: 'Scandalis',
  image,
  pronoun: Pronoun.HE,
  role: ROLE.SOFTWARE_ENGINEER,
};
